<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div>
        <div class="header">
            <div class="header-img" :style="{ 'background-image': imageUrl}" @click="openModal()">
                <v-alert type="warning" v-if="animal.is_deleted && !animal.is_adopted" dismissible>
                    {{ $t('animal_unavailable', {animalName: animal.name}) }}
                </v-alert>
                <v-btn v-if="this.animal.photos.length > 0" class="view-photos" depressed>{{ $t('animal_detail_view_photos_button') }}</v-btn>
            </div>
        </div>
        <div class="listing-container">
            <div class="heading">
                <div class="display-2">{{ animal.name }}</div>
                <v-chip color="red" label text-color="white" class="mt-3" v-if="animal.is_adopted" small>{{ $t('animal_status_adopted') }}</v-chip>
                <v-chip color="red" label text-color="white" class="mt-3" v-if="animal.is_reserved" small>{{ $t('animal_status_reserved') }}</v-chip></div>
            <div class="lists">
                <feature-list  :items="properties">
                    <template slot-scope="properties">
                        <div class="property">{{ properties.title }}: <strong>{{ properties.value }}</strong></div>
                    </template>
                </feature-list>
            </div>
            <!--<div class="lists">-->
                <!--<feature-list title="Personality" :items="personality">-->
                    <!--<template slot-scope="personality">-->
                        <!--<div class="body-1">{{ personality.title }}: <strong>{{ personality.value }}</strong></div>-->
                    <!--</template>-->
                <!--</feature-list>-->
            <!--</div>-->
            <v-divider />
            <div class="description">
                <div class="headline font-weight-bold" style="margin-bottom: 10px;">{{ $t('animal_detail_description_title') }}</div>
                <div><span v-html="animal.description ? animal.description : $t('animal_detail_description_empty')"></span></div>
            </div>
            <v-divider />
            <div class="about">
                <div class="headline font-weight-bold" style="margin-bottom: 10px;">{{ $t('animal_detail_contact_title') }}</div>
            </div>
            <div v-for="organisation in animal.organisations">
                <div style="margin-top: 10px; margin-bottom: 20px">
                    <div class="title font-weight-regular" style="margin-bottom: 10px;">{{ organisation.name }}</div>
                    <div class="body-2" v-if="organisation.website" style="margin-left: -6px; margin-top: 6px;"><v-icon small style="width:30px;">fa-home</v-icon><a :href="organisation.website" target="_blank">{{ organisation.website }}</a></div>
                    <div class="body-2" v-if="organisation.email" style="margin-left: -6px; margin-top: 6px;"><v-icon small style="width:30px;">fa-envelope</v-icon><a :href="`mailto:${organisation.email}`">{{ organisation.email }}</a></div>
                    <div class="body-2" v-if="organisation.facebook" style="margin-left: -6px; margin-top: 6px;"><v-icon small style="width:30px;">fab fa-facebook-square</v-icon> {{ organisation.facebook }}</div>
                </div>
            </div>
        </div>
        <LightBox
                :images="images"
                :disableScroll="false"
                ref="lightbox"
                :show-caption="false"
                :show-light-box="false">
        </LightBox>
    </div>
</template>
<script>
    import LightBox from 'vue-image-lightbox'
    import ModalWindow from './ModalWindow.vue';
    import FeatureList from './FeatureList.vue';

    export default {
        data () {
            return {
                animal: null,
                headerImageStyle: {
                    'background-image': `url(${(this.animal != null && this.animal.photos.length > 0) ? this.animal.photos[0].source.preview.url : require('../assets/pawprint.svg')})`
                }
            }
        },
        computed: {
            images() {
                var data = []
                if(this.animal != null && this.animal.photos.length > 0) {
                    this.animal.photos.forEach(function(photo) { data.push({
                        thumb: photo.source.thumbnail.url,
                        src: photo.source.preview.url
                    })});
                }

                return data;
            },
            imageUrl() {
                return 'url(' + ((this.animal != null && this.animal.photos.length > 0) ? this.animal.photos[0].source.preview.url : require('../assets/pawprint.svg'))  + ')';
            },
            properties() {
                return [
                    {
                        "title": this.$t("animal_detail_property_age"),
                        "value": this.animal.date_of_birth != null ? this.animal.date_of_birth.age_display_name : this.$t("animal_detail_property_value_unknown")
                    },
                    {
                        "title": this.$t("animal_detail_property_size"),
                        "value": this.animal.size != null ? this.animal.size.display_name : this.$t("animal_detail_property_value_unknown")
                    },
                    {
                        "title": this.$t("animal_detail_property_gender"),
                        "value": this.animal.gender != null ? this.animal.gender.display_name : this.$t("animal_detail_property_value_unknown")
                    },
                    {
                        "title": this.$t("animal_detail_property_breed"),
                        "value": this.animal.breed != null ? this.animal.breed.display_name : this.$t("animal_detail_property_value_unknown")
                    },
                    {
                        "title": this.$t("animal_detail_property_country_of_residence"),
                        "value": this.animal.residence_country != null ? this.animal.residence_country.display_name : this.$t("animal_detail_property_value_unknown")
                    },
                    {
                        "title": this.$t("animal_detail_property_available_since"),
                        "value": this.animal.created.display_diff
                    }
                ]
            },
            personality() {
                return [
                    {
                        "title": "Other cats",
                        "value": "Check"
                    },
                    {
                        "title": "Other dogs",
                        "value": "Check"
                    },
                    {
                        "title": "Little children",
                        "value": "Check"
                    },
                    {
                        "title": "Big children",
                        "value": "Check"
                    },
                    {
                        "title": "Home alone",
                        "value": "Check"
                    },
                    {
                        "title": "In car",
                        "value": "Check"
                    }
                ]
            }
        },
        components: {
            LightBox,
            ModalWindow,
            FeatureList
        },
        methods: {
            openModal() {
                if(this.animal.photos.length > 0) {
                    this.$refs.lightbox.showImage(0)
                }
            }
        },
        mounted() {
            require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

            // Load animal info
            axios.get("/api/animal/" + this.$route.params.id)
                    .then(response => {
                        this.animal = response.data;
                        this.$title = this.animal.name;
                    }).catch(function (thrown) {
                        if (axios.isCancel(thrown)) {
                            console.log('Request canceled', thrown.message);
                        } else {
                            // TODO
                        }
                    });
        }
    }
</script>
<style>
    .header {
        height: 320px;
    }

    .header .header-img {
        background-repeat: no-repeat;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-position: 50% 50%;
        background-color: #f5f5f5;
        height: 100%;
        cursor: pointer;
        position: relative;
    }

    .header .header-img .view-photos {
        position: absolute;
        bottom: 20px;
        left: 20px;
    }

    .heading {
        margin-bottom: 2em;
    }

    .about {
        margin: 2em 0;
    }

    .description {
        margin: 2em 0;
        font-size: 18px!important;
        font-style: normal;
        font-weight: 400;
        letter-spacing: .8px;
        line-height: 35px;
    }

    .listing-container {
        margin: 0 auto;
        padding: 0 12px;
        margin-top: 24px;
    }

    .property {
        font-size: 18px!important;
        line-height: 1!important;
        letter-spacing: .02em!important;
        font-family: Roboto,sans-serif!important;
    }

    @media (min-width: 744px) {
        .listing-container {
            width: 750px;
        }
    }
</style>